export default __webpack_public_path__ + "static/part-time-advantage-5-4ebd9749ce803adc38cfabc01b51864c.png";